export enum SubType {
  TRIAL = 'TRIAL',
  BETA = 'BETA',
  STANDARD = 'STANDARD',
}

export enum SubStatus {
  CANCELED = 'CANCELED',
  UNPAID = 'UNPAID',
}
